var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: "#FFF" }),
      React.createElement(
        "g",
        { fill: "#F36363", transform: "translate(18 6)" },
        React.createElement("rect", { width: "3", height: "3", x: ".4", y: "23", rx: "1.5" }),
        React.createElement("rect", { width: "2.2", height: "18", x: ".8", rx: "1.1" })
      )
    )
  );
});